const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
const normalizeHeaders = (headers) => {
    if (!headers) {
        return {};
    }
    if (headers instanceof Headers) {
        const normalized = {};
        headers.forEach((value, key) => {
            normalized[key] = value;
        });
        return normalized;
    }
    if (Array.isArray(headers)) {
        return Object.fromEntries(headers);
    }
    return Object.fromEntries(Object.entries(headers).map(([key, value]) => [key, typeof value === "string" ? value : value.join(", ")]));
};
export const fetchPassioWithRetry = async (url, init, { getAuth, invalidateAuth, maxAttempts = 4 }) => {
    let auth = await getAuth();
    let retried401 = false;
    let backoffMs = 1000;
    for (let attempt = 0; attempt < maxAttempts; attempt++) {
        const response = await fetch(url, {
            ...init,
            headers: {
                ...normalizeHeaders(init.headers),
                Authorization: `Bearer ${auth.accessToken}`,
                "Passio-ID": auth.customerId,
            },
        });
        if (response.status === 401 && !retried401) {
            invalidateAuth?.();
            auth = await getAuth();
            retried401 = true;
            continue;
        }
        if (response.status === 402) {
            return response;
        }
        if ((response.status === 429 || response.status >= 500) && attempt < maxAttempts - 1) {
            await sleep(backoffMs);
            backoffMs *= 2;
            continue;
        }
        return response;
    }
    throw new Error("Passio request failed after retries");
};
//# sourceMappingURL=passioFetchWithRetry.js.map